import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, GradeOptions, StudentSexOptions, TermFilter } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/student-level-section/StudentAssignmentAction";
import { useStudentLevelSectionUIContext } from "../StudentLevelSectionUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, grade, section, studentName, sex, levelSection, levelCourseId } = values;
  const newQueryParams = { ...queryParams };
  const filter = { grade, section, studentName, sex, levelSection, levelCourseId };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function StudentLevelSectionFilter() {
  // Student Level Section UI Context
  const studentLevelSectionUIContext = useStudentLevelSectionUIContext();
  const studentLevelSectionUIProps = useMemo(() => {
    return {
      setQueryParams: studentLevelSectionUIContext.setQueryParams,
      queryParams: studentLevelSectionUIContext.queryParams,
    };
  }, [studentLevelSectionUIContext]);
  
  const dispatch = useDispatch();
  const { currentActiveTerm, courses } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      courses: state.studentLevelSection.allCourses
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getAllLevelCourses());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(studentLevelSectionUIProps.queryParams, values);
    if (!isEqual(newQueryParams, studentLevelSectionUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      studentLevelSectionUIProps.setQueryParams(newQueryParams);
    }
  };

  const gradeOptions = FilterOptions.concat(GradeOptions);
  const sexOptions = FilterOptions.concat(StudentSexOptions);
  const courseOptions = FilterOptions.concat(courses);

  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        section: "",
        studentName: "",
        levelSection: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="section"
                placeholder="Şube"
                onBlur={handleBlur}
                value={values.section}
                onChange={(e) => {
                  setFieldValue("section", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentName"
                placeholder="Adı Soyadı"
                onBlur={handleBlur}
                value={values.studentName}
                onChange={(e) => {
                  setFieldValue("studentName", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sexOptions}
                value={values.sex}
                placeholder="Cinsiyeti"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sex", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cinsiyeti</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="levelSection"
                placeholder="Kur Sınıfı"
                onBlur={handleBlur}
                value={values.levelSection}
                onChange={(e) => {
                  setFieldValue("levelSection", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kur Sınıfı</b>
              </small>
            </div>            
            <div className="col-lg-2">
              <CustomSelect 
                options={courseOptions}
                value={values.levelCourseId}
                placeholder="Kur Dersi"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("levelCourseId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kur Dersi</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}